import Icon from 'veui/components/Icon'
import { IconQuestionComment } from 'dls-icons-vue'

Icon.register('question-comment', IconQuestionComment)
